/* This file is autogenerated, see readme.md for instructions */
import FormulaExpressionSvgIcon from '@bloomreach/banana-theme/icons/formula-expression-.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const FormulaExpressionIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <FormulaExpressionSvgIcon />
    </Icon>
  );
});

FormulaExpressionIcon.displayName = 'FormulaExpressionIcon';

export default FormulaExpressionIcon;
